var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn",on:{"click":_vm.copyAction}},[_c('img',{staticClass:"img-icon",attrs:{"src":require("../../../assets/invoice/ic_copy.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }